import { render, staticRenderFns } from "./FeeValues.vue?vue&type=template&id=637df3bc&"
import script from "./FeeValues.vue?vue&type=script&lang=js&"
export * from "./FeeValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports